<template>
  <div class="indexPage">
    <div class="swipe">
      <div class="content">
        <div class="content-title">用我们的平台</div>
        <div class="line"></div>
        <div class="title">让保险更简单阳光</div>
        <div class="title">成就更多人的幸福</div>
        <div class="content-more" @click="goRouter('about', 'aboutBrief')">
          <span>了解更多</span>
        </div>
      </div>
    </div>
    <div class="six">
      <div class="title">六大赋能体系</div>
      <div class="content">
        <div class="item" v-for="item in sixList" :key="item.id" @click="goRouter('advantage', item.route)">
          <img :src="item.url" alt="">
          <div class="top">{{ item.title }}</div>
          <div class="text">{{ item.first }}</div>
          <div class="text">{{ item.second }}</div>
        </div>
      </div>
    </div>
    <div class="cooper">
      <div class="title">合作伙伴</div>
      <div class="content">
        <div class="cooperImg">
          <img style="width:150px;" src="../assets/images/logo_1.png" alt="">
        </div>
        <div class="cooperImg">
          <img style="width:174px;" src="../assets/images/logo_2.png" alt="">
        </div>
        <div class="cooperImg">
          <img style="width:132px;" src="../assets/images/logo_3.png" alt="">
        </div>
        <div class="cooperImg">
          <img style="width:132px;" src="../assets/images/logo_4.png" alt="">
        </div>
        <div class="cooperImg">
          <img style="width:174px;" src="../assets/images/logo_5.png" alt="">
        </div>
        <div class="cooperImg">
          <img style="width:120px;" src="../assets/images/logo_6.png" alt="">
        </div>
        <div class="cooperImg">
          <img style="width:138px;" src="../assets/images/logo_7.png" alt="">
        </div>
        <div class="cooperImg">
          <img style="width:156px;" src="../assets/images/logo_8.png" alt="">
        </div>
        <div class="cooperImg">
          <img style="width:144px;" src="../assets/images/logo_9.png" alt="">
        </div>
        <div class="cooperImg">
          <img style="width:130px;" src="../assets/images/logo_10.png" alt="">
        </div>
      </div>
      <div class="more" @click="goRouter('advantage', 'advantageProduct')">
        <span>查看更多</span>
      </div>
    </div>
    <div class="six news">
      <div class="title">新闻动态</div>
      <div class="content">
        <div class="item" v-for="item in newsList" :key="item.id" @click="goDetail(item.link)">
          <img :src="item.url" alt="">
          <div class="top">{{ item.title }}</div>
          <div class="intro">{{ item.intro }}</div>
        </div>
      </div>
      <div class="more" @click="goRouter('about', 'aboutNews')">
        <span>查看更多</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  components: {},
  data() {
    return {
      sixList: [{
        id: '1',
        title: '产品赋能',
        first: '云桥：智慧产品工厂整合百余家产寿保险公司',
        second: '丰富的产品线，覆盖客户全生命周期',
        url: require('../assets/images/home_icon_chanpin_normal.png'),
        route: 'advantageProduct'
      },
      {
        id: '2',
        title: '客户赋能',
        first: '云链：聚合海量客户需求入口，协同',
        second: '线下队伍高价值转化',
        url: require('../assets/images/home_icon_ziyuan_normal.png'),
        route: 'advantageResources'
      },
      {
        id: '3',
        title: '培训赋能',
        first: '专注于保险顾问全渠道、全职业生',
        second: '涯的成长需求',
        url: require('../assets/images/home_icon_peixun_normal.png'),
        route: 'advantageTrain'
      },
      {
        id: '4',
        title: '营销赋能',
        first: '专业的营销管理与服务体系：传统模式→事',
        second: '务所→ABO众创→家族办公室',
        url: require('../assets/images/home_icon_funeng_normal.png'),
        route: 'advantageMarketing'
      },
      {
        id: '5',
        title: '服务赋能',
        first: '“真托管心理赔”简单阳光高效理赔＋TPA',
        second: '增值服务，促进客户黏性与活跃',
        url: require('../assets/images/home_icon_fuwu_normal.png'),
        route: 'advantageService'
      },
      {
        id: '6',
        title: '科技赋能',
        first: '云创：提供SaaS化鲸云保展业系统及数智化',
        second: '核心系统，助力业务高效拓展',
        url: require('../assets/images/home_icon_keji_normal.png'),
        route: 'advantageTech'
      }
      ],
      newsList: [
        {
          id: '1',
          title: '【荣誉殿堂】风采展示-壹心保代篇',
          intro: '公司标保MDRT更是行业中的尖端，入围标准远超行业MDRT。你们站在了荣誉的巅峰，是公司的骄傲，也是行业的翘楚。',
          url: require('../assets/images/news-1.jpeg'),
          link: 'https://mp.weixin.qq.com/s/76G4pMjIHtNPx-g0xyOJmw',
        },
        {
          id: '2',
          title: '壹心科技全体员工给您拜年啦！',
          intro: '祝您在新的一年里虎啸山林，龙腾虎跃。',
          url: require('../assets/images/news-2.png'),
          link: 'https://mp.weixin.qq.com/s/wCo7W-W7g6_7Cy5dFjtRpw',
        },
        // {
        //   id: '3',
        //   title: '【破亿】热烈祝贺壹心个险业务1月单月保费规模破亿',
        //   intro: '壹心有你，大事可期',
        //   url: require('../assets/images/news-3.jpeg'),
        //   link: 'https://mp.weixin.qq.com/s/0iz49BBzKgsHAz1J3oNx4w',
        // },
        {
          id: '4',
          title: '【年度盘点】2021-2022壹心年度盘点',
          intro: '凝心聚力踏新程，上下同欲开新篇',
          url: require('../assets/images/news-4.jpeg'),
          link: 'https://mp.weixin.qq.com/s/wc9YCpJG-SL_gaDdCky2_A',
        },
        {
          id: '5',
          title: '喜迎建党百年 ｜壹心组织收看庆祝中国共产党成立一百周年大会',
          intro: '百年征程波澜壮阔，百年初心历久弥坚',
          url: require('../assets/images/news-5.jpeg'),
          link: 'https://mp.weixin.qq.com/s/Ri3v977JVg1N14agzMk9hg',
        },
      ]
    }
  },
  computed: {},
  created() {

  },
  mounted() { },
  methods: {
    goRouter(name, firstTab) {
      if (firstTab === this.$route.params.pathId) return
      this.$router.push({
        path: firstTab ? `/${name}/${firstTab}` : `/${name}`,
      })
      this.$forceUpdate()
    },
    goDetail(val) {
      window.open(val)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.indexPage {
  .swipe {
    width: 100vw;
    height: 40vw;
    min-width: 1200px;
    min-height: 480px;
    position: relative;
    background: url('../assets/images/picture_banner.png') no-repeat;
    background-size: 100% 100%;

    .content {
      position: absolute;
      right: 15%;
      top: 15%;
      color: #ffffff;
      text-align: right;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

    .content-title {
      font-size: 32px;
    }

    .content-more {
      width: 177px;
      height: 58px;
      line-height: 58px;
      border: 2px solid #FFFFFF;
      font-size: 20px;
      font-weight: 600;
      margin-top: 88px;
      text-align: center;
    }

    .line {
      width: 92px;
      height: 3px;
      background: #FFFFFF;
      margin: 16px 0 32px;
    }

    .title {
      font-size: 48px;
      font-weight: 600;
    }
  }

  .more {
    width: 164px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #FFFFFF;
    color: #FFFFFF;
    text-align: center;
    margin: 0 auto;
    font-size: 16px;
  }

  .six {
    width: 100vw;
    min-width: 1200px;
    padding: 88px 0;
    background-color: #ffffff;

    .title {
      font-size: 28px;
      font-weight: 600;
      text-align: center;
    }

    .content {
      width: 1024px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 0 auto;
    }

    .item {
      width: 320px;
      height: 296px;
      background-color: #ffffff;
      text-align: center;
      padding-top: 40px;
      border-radius: 4px;
      margin-top: 48px;
      box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);

      img {
        width: 90px;
      }

      .top {
        font-size: 20px;
        margin: 16px 0 10px;
        font-weight: 600;
      }

      .text {
        color: #999999;
      }
    }
  }

  .cooper {
    background-color: #333333;
    width: 100vw;
    min-width: 1200px;
    padding: 88px 0;
    color: #FFFFFF;

    .title {
      height: 60px;
      font-size: 28px;
      font-weight: 600;
      text-align: center;
    }

    .content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      width: 1024px;
      margin: 0 auto;
      margin-bottom: 48px;
    }

    .cooperImg {
      width: 180px;
      height: 88px;
      margin-top: 30px;
      border: 1px solid #E7E7E7;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ffffff;

      img {
        display: block;
      }
    }
  }

  .news {
    .item {
      padding: 0 0 24px;
      width: 235px;
      height: auto;
      text-align: left;
      box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);

      img {
        width: 235px;
        height: 118px;
      }

      .top {
        font-size: 18px;
        padding: 0 16px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .intro {
        font-size: 14px;
        color: #999999;
        padding: 0 16px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
      }
    }

    .more {
      border: 1px solid #AAAAAA;
      color: #AAAAAA;
      margin: 48px auto 0;
    }
  }
}
</style>